export const Features = [
  {
    title: "GPS Fleet Tracking & Real-Time Vehicle Tracking",
    icon: "/IndustryImages/featureIcon1.svg",
    alt: "GPS Fleet Tracking",
    description:
      "Get live GPS updates on routes, stops, and mileage with our powerful GPS fleet tracking system. Gain total accountability and optimize routes in real time.",
  },
  {
    title: "Fuel Management with Digital Fuel Cards",
    icon: "/IndustryImages/featureIcon2.svg",
    alt: "Fuel Management",
    description:
      "Optimize fuel usage and reduce waste with smart digital fuel cards for fleet. Prevent fraud and track expenses seamlessly.",
  },
  {
    title: "Proactive Driver Monitoring",
    icon: "/IndustryImages/featureIcon3.svg",
    alt: "Proactive Driver Monitoring",
    description:
      "Detect risky driving behaviors, improve safety, and reduce liability with our driver monitoring system.",
  },
  {
    title: "Automated Maintenance Alerts",
    icon: "/IndustryImages/featureIcon4.svg",
    alt: "Automated Maintenance",
    description:
      "Stay ahead of breakdowns with timely fleet maintenance software alerts that notify you before issues become costly.",
  },
  {
    title: "Delivery Fleet Scheduling Software",
    icon: "/IndustryImages/featureIcon5.svg",
    alt: "Delivery Fleet Scheduling",
    description:
      "Manage delivery timelines effectively with automated scheduling, ensuring timely service and reducing delays.",
  },
  {
    title: "Smart Notifications",
    icon: "/IndustryImages/featureIcon6.svg",
    alt: "Smart Notifications",
    description:
      "Get instant alerts for accidents, breakdowns, or route deviations to avoid costly disruptions.",
  },
  {
    title: "Cost Optimization & Analytics",
    icon: "/IndustryImages/featureIcon7.svg",
    alt: "Cost Optimization",
    description:
      "Comprehensive reports and analytics highlight cost-saving opportunities with powerful fleet optimization software.",
  },
  {
    title: "Mobile Fleet Management App",
    icon: "/IndustryImages/featureIcon8.svg",
    alt: "Mobile Fleet Management App",
    description:
      "Manage your fleet anytime, anywhere, with our mobile-friendly app. The Canvendor mobile fleet management app ensures real-time fleet visibility on the go.",
  },
];

export const fleetBenefits = [
  {
    title: "Boost Profitability",
    icon: "/IndustryImages/benefit3.svg",
    alt: "Boost Profitability",
    description: "Slash operating costs with reduced fuel waste and downtime.",
  },
  {
    title: "Enhance Safety",
    icon: "/IndustryImages/benefit2.svg",
    alt: "Enhance Safety",
    description:
      "Protect drivers and vehicles through continuous, proactive monitoring.",
  },
  {
    title: "Increase Productivity",
    icon: "/IndustryImages/benefit1.svg",
    alt: "Increase Productivity",
    description: "Streamline operations and optimize routes efficiently.",
  },
  {
    title: "Gain Total Visibility",
    icon: "/IndustryImages/benefit4.svg",
    alt: "Gain Total Visibility",
    description:
      "Monitor your fleet’s real-time performance and location from any device.",
  },
  {
    title: "Ensure Compliance",
    icon: "/IndustryImages/benefit5.svg",
    alt: "Boost Profitability",
    description:
      "Stay aligned with regulations using built-in fleet compliance software.",
  },
  {
    title: "Drive Sustainability",
    icon: "/IndustryImages/benefit6.svg",
    alt: "Drive Sustainability",
    description:
      "Minimize your environmental impact with smarter fuel and route management.",
  },
];
